import { createSlice } from "@reduxjs/toolkit";

const saved = JSON.parse(localStorage.getItem("auth") || "{}");

const initialState = {
  token: saved.token || null,
  user: saved.user || null, // { id, name, email, role }
};

const slice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setCredentials: (state, action) => {
      const { token, user } = action.payload;
      state.token = token;
      state.user = user;
      localStorage.setItem("auth", JSON.stringify({ token, user }));
    },
    logout: (state) => {
      console.log("🚪 LOGOUT ACTION DISPATCHED");
      console.trace("Logout call stack:"); // This will show where logout was called from
      state.token = null;
      state.user = null;
      localStorage.removeItem("auth");
      console.log("✅ User logged out and localStorage cleared");
    },
    setUserOnly: (state, action) => {
      console.log("👤 setUserOnly called with:", action.payload);
      state.user = action.payload;
      localStorage.setItem(
        "auth",
        JSON.stringify({ token: state.token, user: state.user })
      );
      console.log("✅ User updated and saved to localStorage");
    },
  },
});

export const { setCredentials, logout, setUserOnly } = slice.actions;
export default slice.reducer;

// Enhanced selectors with debugging
export const selectToken = (state) => {
  const token = state.auth.token;
  // Only log occasionally to avoid spam
  if (Math.random() < 0.1) {
    console.log("🔍 selectToken called, token:", token ? "Present" : "Missing");
  }
  return token;
};

export const selectUser = (state) => {
  const user = state.auth.user;
  // Only log occasionally to avoid spam
  if (Math.random() < 0.1) {
    console.log("🔍 selectUser called, user:", user);
  }
  return user;
};

export const selectIsAuthed = (state) => Boolean(state.auth.token);
